export type OnBlurType =
  | 'email'
  | 'password'
  | 'name'
  | 'lastName'
  | 'birthDate';

export type ValidationState = {
  email?: string | null;
  password?: string | null;
  name?: string | null;
  lastName?: string | null;
  birthDate?: string | null;
  general?: string | null;
};

export type SetValidationState = React.Dispatch<
  React.SetStateAction<ValidationState>
>;

export const onBlur = (
  value: string,
  type: OnBlurType,
  setState: SetValidationState,
) => {
  if (type === 'email') {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
    const isYopmail = /@yopmail\.com$/i.test(value);

    const error =
      !emailRegex.test(value) || isYopmail ? 'Ingresa un email válido' : null;

    setState((prev) => ({
      ...prev,
      email: error,
    }));

    return;
  } else if (type === 'password') {
    setState((prev) => ({
      ...prev,
      password: value.length === 0 ? 'Ingresa la contraseña' : null,
    }));

    return;
  } else if (type === 'name' || type === 'lastName') {
    const nameRegex = /^[A-Za-zÀ-ÿ\s]+$/;

    let error: string | null = null;

    if (value.trim().length < 2) {
      error = 'Debe tener al menos 2 caracteres';
    } else if (!nameRegex.test(value)) {
      error = 'Solo puede contener letras';
    }

    setState((prev) => ({
      ...prev,
      [type]: error,
    }));

    return;
  } else if (type === 'birthDate') {
    const birth = new Date(value);
    const today = new Date();

    let error: string | null = null;

    if (!value) {
      error = 'Ingresa tu fecha de nacimiento';
    } else {
      let age = today.getFullYear() - birth.getFullYear();
      const month = today.getMonth() - birth.getMonth();

      if (month < 0 || (month === 0 && today.getDate() < birth.getDate())) {
        age--;
      }

      if (age < 18) {
        error = 'Debes ser mayor de edad';
      }
    }

    setState((prev) => ({
      ...prev,
      birthDate: error,
    }));

    return;
  }

  return;
};

export type PasswordError =
  | 'length'
  | 'uppercase'
  | 'lowercase'
  | 'number'
  | 'character';

export const validatePassword = (value: string): PasswordError[] => {
  const errors: PasswordError[] = [];

  if (value.length < 6) errors.push('length');
  if (!/[A-Z]/.test(value)) errors.push('uppercase');
  if (!/[a-z]/.test(value)) errors.push('lowercase');
  if (!/[0-9]/.test(value)) errors.push('number');
  if (!/[^A-Za-z0-9]/.test(value)) errors.push('character');

  return errors;
};
